import React, { useEffect, useRef } from "react";

const ChatBox = ({ messages, userType }) => {
  const bottomRef = useRef();

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  return (
    <div className="chat-body">
      {messages.map((msg, index) => (
        <div
          key={index}
          className={`chat-message ${
            msg.sender_type === userType ? "sent" : "received"
          }`}
        >
          <div className="message-text">{msg.message}</div>
          <small>{msg.time}</small>
        </div>
      ))}
      <div ref={bottomRef} />
    </div>
  );
};

export default ChatBox;
